import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-d297f612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Zero Waste Box™ ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "subtitle" }, " The simple, all-in-one solution to recycle hard-to-recycle trash. ", -1))
const _hoisted_6 = { class: "box-search" }
const _hoisted_7 = { class: "main" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "box-taxons" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "card-taxon-content" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "learn-more" }, [
  /*#__PURE__*/_createTextVNode(" Learn more "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_14 = { class: "how-it-works" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-title" }, " HOW IT WORKS ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " We make recycling easy: simply choose the Zero Waste Box™ for what you’d like to recycle, fill the box, and send it back to TerraCycle when you’re ready. We take care of the rest! ", -1))
const _hoisted_17 = { class: "box-step" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "section-title" }, " Featured products ", -1))
const _hoisted_20 = { class: "box-products" }
const _hoisted_21 = { class: "row" }

import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { request } from '@/utils';
  import { Collection } from '@/stores';
  import { ITaxon } from '@/types/taxon';
  import StepCard from './components/card-step.vue';

  
export default /*#__PURE__*/_defineComponent({
  props: {},
  setup(__props) {

  

  const taxons: ITaxon[] = [
    {
      id: 1,
      name: 'Sponsored box',
      image: {
        signed_id: '',
        url: 'https://via.placeholder.com/540x760',
        id: '1',
        content_type: 'image',
        filename: 'image',
        byte_size: '100'
      }
    },
    {
      id: 2,
      name: 'BEST SELLERS',
      image: {
        signed_id: '',
        url: 'https://via.placeholder.com/540x760',
        id: '1',
        content_type: 'image',
        filename: 'image',
        byte_size: '100'
      }
    },
    {
      id: 3,
      name: 'SPECIAL ZWB FOR THIS MONTH',
      image: {
        signed_id: '',
        url: 'https://via.placeholder.com/540x760',
        id: '1',
        content_type: 'image',
        filename: 'image',
        byte_size: '100'
      }
    },
    {
      id: 4,
      name: 'FOR SALE',
      image: {
        signed_id: '',
        url: 'https://via.placeholder.com/540x760',
        id: '1',
        content_type: 'image',
        filename: 'image',
        byte_size: '100'
      }
    }
  ];

  const steps = [
    {
      title: 'Shop',
      icon: require('./images/step-1.png'),
      description: 'Browse our selection of Zero Waste Boxes and select the one that fits your needs.'
    },
    {
      title: 'Collect',
      icon: require('./images/step-2.png'),
      description: 'Fill your Zero Waste Box with the trash you’d like to recycle.'
    },
    {
      title: 'Ship',
      icon: require('./images/step-3.png'),
      description: 'When filled, send your box back to us using the attached prepaid shipping label and we’ll #RecycleEverything!'
    }
  ];

  const breadcurmbRoutes = [
    {
      name: 'Home',
      to: { name: 'home' }
    },
    {
      name: 'Shop'
    }
  ];
  const router = useRouter();
  const keyword = ref('');
  // TODO: 读shop首页自定义列表
  const store = Collection.create<Collection>({
    params: {
      per_page: 3,
    },
    fetch(params = {}) {
      return request.get('/bean/variants', { params });
    }
  });

  function handleSearch() {
    router.push({ name: 'variant.list', query: { keyword: keyword.value } });
  };

  function handlePagination(page: any) {
    store.fetchData({ page });
  }

  onMounted(() => {
    store.fetchData();
  });


return (_ctx: any,_cache: any) => {
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppCardVariant = _resolveComponent("AppCardVariant")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_AppSearch, {
              modelValue: keyword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
              placeholder: "What do you want to recycle？",
              onSearch: handleSearch
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_AppBreadcurmb, {
          class: "section-breadcurmb",
          routes: breadcurmbRoutes
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(taxons, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                class: "col-12 col-md-3"
              }, [
                _createElementVNode("div", {
                  class: "card-taxon",
                  style: _normalizeStyle({ backgroundImage: `url('${item.image.url}')` })
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1),
                    _hoisted_13
                  ])
                ], 4)
              ])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (item, index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: "col-12 col-md-4"
                }, [
                  _createVNode(StepCard, {
                    class: "step-card-item",
                    index: index + 1,
                    title: item.title,
                    description: item.description,
                    icon: item.icon
                  }, null, 8, ["index", "title", "description", "icon"])
                ])
              }), 64))
            ])
          ])
        ]),
        (_unref(store).data.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-12 col-md-4"
                    }, [
                      _createVNode(_component_AppCardVariant, {
                        modelValue: _unref(store).data[index],
                        "onUpdate:modelValue": ($event: any) => ((_unref(store).data[index]) = $event),
                        class: "product-item"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]))
                  }), 128))
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_unref(store).meta.total)
          ? (_openBlock(), _createBlock(_component_AppPagination, {
              key: 1,
              class: "product-pagination",
              simple: "",
              total: _unref(store).meta.total,
              "per-page": _unref(store).meta.per_page,
              page: _unref(store).meta.page,
              onChange: handlePagination
            }, null, 8, ["total", "per-page", "page"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})